import { type MutableRefObject, useLayoutEffect, useState } from 'react'

const isEqual = (a: DOMRect | undefined, b: DOMRect | undefined) =>
  a &&
  b &&
  (['top', 'left', 'width', 'height'] as const).every(
    (key) => a[key] === b[key]
  )

const useBoundingClientRect = (
  ref: MutableRefObject<HTMLElement | null>
): DOMRect | undefined => {
  const [rect, setRect] = useState<DOMRect>()

  useLayoutEffect(() => {
    if (ref.current) {
      const newRect = ref.current?.getBoundingClientRect()
      if (!isEqual(rect, newRect)) {
        setRect(newRect)
      }
    }
  }, [ref.current])

  return rect
}

export default useBoundingClientRect
